import { render, staticRenderFns } from "./SessionList.vue?vue&type=template&id=32621e4e&scoped=true&"
import script from "./SessionList.vue?vue&type=script&lang=js&"
export * from "./SessionList.vue?vue&type=script&lang=js&"
import style0 from "./SessionList.vue?vue&type=style&index=0&id=32621e4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32621e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/nextcloud/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32621e4e')) {
      api.createRecord('32621e4e', component.options)
    } else {
      api.reload('32621e4e', component.options)
    }
    module.hot.accept("./SessionList.vue?vue&type=template&id=32621e4e&scoped=true&", function () {
      api.rerender('32621e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/text/src/components/SessionList.vue"
export default component.exports